import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle retrieve all payments
export const retrieveAllPayments = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      status: data?.status || null,
      type: data?.type || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
      startDate: data?.startDate || null,
      endDate: data?.endDate || null,
    }

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/payment/all`,
        params,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)
